var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "trait" } }, [
    _c("div", { staticClass: "trait-tab-box" }, [
      _c(
        "div",
        { staticClass: "trait-tab" },
        _vm._l(_vm.traitList, function(item, index) {
          return _c(
            "nuxt-link",
            {
              key: index,
              class: { active: _vm.thisHref == item.link },
              attrs: { to: item.link }
            },
            [_vm._v(_vm._s(item.title))]
          )
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e84dc70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e84dc70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/trait/BannerSearch.vue
// module id = +1bP
// module chunks = 20 21